import React, { useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  Row,
  Col,
} from 'reactstrap';
import Select from 'react-select';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createAccountTransaction } from '../../../slices/account-transaction/thunk';
import CurrencyInput from '../../../Components/Common/CurrencyInput';
import { useDispatch } from 'react-redux';

const toNumber = (value) => {
  if (!value) return 0;
  const normalized = String(value).replace(/\./g, '').replace(',', '');
  return parseFloat(normalized) || 0;
};

const CreateAccountTransaction = (props) => {
  const { accountTransactionType, t } = props;
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    type: 'credit',
    amount: '',
    identifier: null,
    identifier_type: "manual_operation"
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    setFormData((prev) => ({
      ...prev,
      [name]: selectedOption?.value || '',
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsSubmitting(true);

    try {
      const amountValue = toNumber(formData.amount);


      if (!amountValue && amountValue <= 0) {
        setIsSubmitting(false);
        toast.error('Valor deve ser definido e maior que zero');
        return;
      }

      const accountTransactionData = {
        type: formData.type,
        amount: amountValue,
        identifier: formData.identifier,
        identifier_type: formData.identifier_type
      };

      const result = await dispatch(
        createAccountTransaction(accountTransactionData)
      );

      if (result?.payload?.error) {
        throw result.payload
      }

      setIsSubmitting(false);
      props.onSuccess();
      handleClose();
    } catch (error) {
      console.error('Error creating account transaction:', error);
      setIsSubmitting(false);
      toast.error(error?.message?.detail?.[0] || 'Erro');
    }
  };

  const handleClose = () => {
    setFormData({
      type: 'credit',
      amount: '',
      identifier: null,
      identifier_type: "manual_operation"
    });
    props.toggle();
  };

  return (
    <Modal
      centered
      isOpen={props.isOpen}
      size="md"
      style={{ transition: 'all 0.2s ease' }}
      toggle={handleClose}
      id="accountTransactionModal"
    >
      <ModalHeader className="bg-info-subtle p-3" toggle={handleClose}>
        {props.t('account-transaction-management.modal.title')}
      </ModalHeader>

      <Form
        className="tablelist-form"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
          return false;
        }}
      >
        <ModalBody>
          <div className="d-flex flex-column gap-4">
            <Row>
              <Col md="12">
                <label className="form-label" htmlFor="type">
                  {t('account-transaction-management.form.type')}
                </label>
                <div className="input-group">
                  <Select
                    id="type"
                    name="type"
                    value={accountTransactionType.find(
                      (opt) => opt.value === formData.type
                    )}
                    onChange={handleSelectChange}
                    options={accountTransactionType}
                    placeholder={t('select')}
                    isClearable
                    isDisabled
                    required
                  />
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="12">
                <label className="form-label" htmlFor="amount">
                  {t('account-transaction-management.form.amount')}
                </label>
                <div className="input-group">
                  <span className="input-group-text">R$</span>
                  <CurrencyInput
                    id="amount"
                    name="amount"
                    value={formData.amount}
                    onChange={(value) =>
                      handleInputChange({
                        target: { name: 'amount', value },
                      })
                    }
                    invalid={formData.amount === "0,00"}
                    placeholder="0,00"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>

        <ModalFooter className="border-top pt-3">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            {props.t('cancel')}
          </button>

          <button
            type="submit"
            className="btn btn-success"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                {props.t('saving')}
              </>
            ) : (
              <>
                <i className="ri-check-line label-icon align-middle fs-16 ms-2"></i>
                {props.t('account-transaction-management.submit')}
              </>
            )}
          </button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default withTranslation()(CreateAccountTransaction);
